import { UserRole } from "../pages/useraccount/Userrole";

// Define the possible options for projectaccess, scheduleaccess, modulesaccess, reportsaccess
const ACCESS_CHOICES = ['No Access', 'View Only', 'Edit', 'Owner'];
const REPORT_CHOICES = ['No Access','Owner'];

// Define the possible options for status
const STATUS_CHOICES = ['Active', 'Inactive'];

const CATEGORY_CHOICES = ['Employee', 'Contractor'];

const ROLE_CHOICES = ['Employee', 'ProjectManager','Condructor'];

interface Field {
  title: string;
  // name: keyof UserRole; // Use keyof UserRole to ensure type safety
  name: string;
  type: string;
  width: number;
  height?: number;
  isRequired: boolean;
  options?: string[]; // Options will be set dynamically based on the field name
}

export const UserRolefields: Field[] = [
  {
    title: "Role Name:",
    name: "rolename",
    type: "text",
    width: 450,
    height: 70,
    isRequired: false,
  },
  {
    title: "Status:",
    name: "status",
    type: "dropDown",
    width: 450,
    isRequired: false,
    options: STATUS_CHOICES, // Use STATUS_CHOICES defined above
  },
  {
    title: "Note:",
    name: "note",
    type: "text",
    height: 70,
    width: 350,
    isRequired: false,
  },
  {
    title: "Project Access:",
    name: "projectaccess",
    type: "dropDown",
    width: 450,
    isRequired: false,
    options: ACCESS_CHOICES, // Use ACCESS_CHOICES defined above
  },
  {
    title: "Schedule Access:",
    name: "scheduleaccess",
    type: "dropDown",
    width: 450,
    isRequired: false,
    options: ACCESS_CHOICES, // Use ACCESS_CHOICES defined above
  },
  {
    title: "Module Access:",
    name: "modulesaccess",
    type: "dropDown",
    width: 450,
    isRequired: false,
    options: ACCESS_CHOICES, // Use ACCESS_CHOICES defined above
  },
  {
    title: "Report Access:",
    name: "reportsaccess",
    type: "dropDown",
    width: 450,
    isRequired: false,
    options: REPORT_CHOICES, // Use ACCESS_CHOICES defined above
  },
  {
    title: "Created On:", // Adjust title as needed
    name: "createdon", // Field name for createdon
    type: "date", // Assuming type as date for createdon
    
    width: 450,
    isRequired: false,
  },
];

export const AddUserFields: Field[] = [
  {
    title: "Employee Id",
    name: "employee_id",
    type: "text",
    width: 450,
    height: 70,
    isRequired: false,
  },
  {
    title: "Employee Name",
    name: "username",
    type: "text",
    width: 450,
    isRequired: false,
  },
  {
    title: "Organization",
    name: "organization",
    type: "text",
    height: 70,
    width: 350,
    isRequired: false,
  },
  {
    title: "Email",
    name: "email",
    type: "text",
    width: 450,
    isRequired: false,
    
  },
  {
    title: "Password",
    name: "password",
    type: "text",
    width: 450,
    isRequired: false,
    
  },
  {
    title: "Created Date", // Adjust title as needed
    name: "createddate", // Field name for createdon
    type: "date", // Assuming type as date for createdon
    
    width: 450,
    isRequired: false,
  },
  {
    title: "Category",
    name: "category",
    type: "dropDown",
    width: 450,
    isRequired: false,
    options: CATEGORY_CHOICES, // Use ACCESS_CHOICES defined above
  },
  {
    title: "Role",
    name: "role",
    type: "dropDown",
    width: 450,
    isRequired: false,
    options:ROLE_CHOICES  , 
  },
  {
    title: "Title",
    name: "title",
    type: "text",
    width: 450,
    isRequired: false,
    //options: , // Use ACCESS_CHOICES defined above
  },
  
];
